import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { Order } from "@/model/Order";

export class FabricationOrdersBreakdown implements Serializable {
    ordersToProcess: Order[];
    ordersProcessed: Order[];
    ordersArchived: Order[];
    
    fromJSON(rawObject: any): void {
        if (rawObject['ordersToProcess'] != null) {
            this.ordersToProcess = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new Order(), rawObject['ordersToProcess']);
        }
        if (rawObject['ordersProcessed'] != null) {
            this.ordersProcessed = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new Order(), rawObject['ordersProcessed']);
        }
        if (rawObject['ordersArchived'] != null) {
            this.ordersArchived = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new Order(), rawObject['ordersArchived']);
        }
    }
}
